// components
import LineShape01 from "@/components/shapes/LineShape01";
import PlaneShape02 from "@/components/shapes/PlaneShape02";
import DollShape01 from "@/components/shapes/DollShape01";
import ParasuitShape02 from "@/components/shapes/ParasuitShape02";
import FrameShape04 from "@/components/shapes/FrameShape04";
import BeeShape02 from "@/components/shapes/BeeShape02";
import BottomShape03 from "@/components/shapes/BottomShape03";
// type
import { TMainPageLayoutV3 } from "../type";
// utilities
import { metaDataLanguageVersion } from "@/utilities/LanguageVersionSelectorShortcut";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { isEmpty } from "lodash";
import RMDRTextBox from "@/components/RMDRTextBox";
import RMDRComboBox from "@/components/RMDRComboBox";


type TVerboseResources = {
    formSearchPlaceholderString:string;
    filterOrderBy:string;
    filterItemsPerPage:string;
}

const MNPG059 = ( props: TMainPageLayoutV3 ) => {
    console.log("MNPG059.rendered: ", props);
    
    const [ searchParams, setSearchParams ] = useSearchParams();
    
    const [ verboseResources, setVerboseResources ] = useState<TVerboseResources>({
        formSearchPlaceholderString:"",filterOrderBy:"",filterItemsPerPage:""
    });

    useEffect(
        () => {
            if (isEmpty(verboseResources.formSearchPlaceholderString)) {
                if (props.params?.["contentDetails"]) {
                    const formSearchPlaceholderString = metaDataLanguageVersion("formSearchPlaceholderString", props.params["contentDetails"].languageVersions);
                    const filterOrderBy = metaDataLanguageVersion("filterOrderBy", props.params["contentDetails"].languageVersions);
                    const filterItemsPerPage = metaDataLanguageVersion("filterItemsPerPage", props.params["contentDetails"].languageVersions);
                    setVerboseResources({formSearchPlaceholderString,filterOrderBy,filterItemsPerPage});
                }
            }
        }, [ props.params?.["contentDetails"] ]
    )

    if ( !props.params?.["contentDetails"] ) return null;

    const itemsPerPageOnClick = (name:string, data:any) => {
        if ( data ) {
            searchParams.set(name, data.value );
            searchParams.set("page", "1" );
            setSearchParams(searchParams, { replace:true });
        }
    }

    const orderByOnClick = (name:string, data:any) => {
        if ( data ) {
            searchParams.set(name, data.value );
            searchParams.set("page", "1" );
            setSearchParams(searchParams, { replace:true });
        }
    }

    const formOnSubmit = ( event:React.SyntheticEvent ) => { 
        event.preventDefault();
        const target = event.target as typeof event.target & {
            q: { value: string },
        };

        searchParams.set("q", target.q.value );
        searchParams.set("page", "1" );
        setSearchParams(searchParams, { replace:true });
    }

    return (
        <div className="breadcrumb-wrapper bg-cover">
            <LineShape01 />
            <PlaneShape02 className="float-bob-y" />
            <DollShape01 className="float-bob-x" />
            <ParasuitShape02 className="float-bob-y" />
            <FrameShape04 />
            <BeeShape02 className="float-bob-x" />
            <BottomShape03 />
            <div className="container">
                <div className="search-heading">
                    <div className="row justify-content-end tw-gap-y-3">
                        <form className="col col-12" onSubmit={formOnSubmit}>
                            <RMDRTextBox
                                name={"q"}
                                value={props.params.searchPagePayload?.q}
                                placeholder={verboseResources.formSearchPlaceholderString}
                                className="form-clt"
                            />
                        </form>
                        {
                            !isEmpty(verboseResources.filterItemsPerPage) && (
                                <RMDRComboBox
                                    name="top"
                                    dataSource={JSON.parse(verboseResources.filterItemsPerPage)}
                                    value={props.params.searchPagePayload?.top}
                                    displayExpr="name"
                                    idExpr="value"
                                    searchExpr="name"
                                    className="form-clt col col-12 col-md-6 col-lg-2 md-p-0"
                                    onClick={itemsPerPageOnClick}
                                />
                            )
                        }
                        {
                            !isEmpty(verboseResources.filterOrderBy) && (
                                <RMDRComboBox
                                    name="sort"
                                    dataSource={JSON.parse(verboseResources.filterOrderBy)}
                                    value={props.params.searchPagePayload?.sort}
                                    displayExpr="name"
                                    idExpr="value"
                                    searchExpr="name"
                                    className="form-clt col col-12 col-md-6 col-lg-2"
                                    onClick={orderByOnClick}
                                />
                            )
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MNPG059;
